module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution_three.c013e0ab.png";